import { render, staticRenderFns } from "./CRIcon.vue?vue&type=template&id=13eebda4&scoped=true"
import script from "./CRIcon.vue?vue&type=script&lang=js"
export * from "./CRIcon.vue?vue&type=script&lang=js"
import style0 from "./CRIcon.vue?vue&type=style&index=0&id=13eebda4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13eebda4",
  null
  
)

export default component.exports